import { BehaviorSubject } from 'rxjs';
import { store } from '../../store/store';
import { NotificationType, showNotification, } from '../../store/features/notification';
import { addToast } from '../../modules/core/actions';
import { ToastType } from '../../modules/core/constants';
import { ExtensionsEventsEnum, } from './sdk.types';
import { callFrameSubject, modalSubject } from './index';
import { MessageType } from '../../store/features/messages';
import { callEndedByPatientManuallySubscription, callEndedByDoctorManuallySubscription, activeProviderEndReasonSubscription, personManuallyRemovedFromCallSub, doctorLeftSubscription, callOnHoldSubscription, callPausedForPatientSubscription, angularModalOpenedSubscription, angularModalClosedSubscription, personAddedToGroupCallSubscription, sessionConnectedSubscription, sessionDisconnectedSubscription, screenSharingUpdatedSubscription, screenSharingStartedSubscription, screenPublisherErrorSubscription, } from './subscriptions';
import { AngularMethods, AngularServices, angularServicesIntegration, } from './angular-integration/integration-types';
import { createExtensionRequest } from '../../vendor/api';
import { getDoctor, getPatients, getCurrentUser, getInstitution, } from './helpers';
// used direct import due to errors 'yarn test-unit'
import { localeService, getAngularService } from '../core/helpers';
let sendMessageFunc = null;
export const setMessageFunc = (func) => {
    // set func add id into message
    sendMessageFunc = func;
};
export const componentState = {
    callDetails: null,
    doctor: null,
    institution: null,
    extensionMessages: null,
};
export const behaviorState = new BehaviorSubject(componentState);
export const extensionHandlers = new Map();
export const handleStateChange = () => {
    const state = store.getState();
    let lowQualityPhoto = true;
    if (state.system.user) {
        let institutionRole = null;
        if (state.system.institution) {
            const targetMember = state.system.user.institutionsMemberships.find((member) => member.institutionId === state.system.institution.id);
            if (targetMember) {
                institutionRole = targetMember.role;
            }
        }
        lowQualityPhoto = state.system.user.lowQualityPhoto;
        componentState.doctor = getDoctor(state.user, state.system.user.subscriptionType, institutionRole);
    }
    if (state.system.institution) {
        componentState.institution = getInstitution(state.system.institution);
    }
    componentState.callDetails = {
        // realTimePatients - patients that are located in the waiting queue of provider (not in the current call)
        realTimePatients: getPatients(state.realtime.patients),
        room: state.callInfo.room,
        callSession: state.callInfo.callSession,
        isInGroupCall: state.callInfo.isInGroupCall,
        currentUser: getCurrentUser(state.user, lowQualityPhoto),
    };
    componentState.extensionMessages = state.messages.extensionMessage;
    behaviorState.next(componentState);
};
export const actions = {
    showNotification: (text, type) => {
        if (type !== NotificationType.DIALOG) {
            store.dispatch(addToast(ToastType[type.toLowerCase()], text));
        }
        else {
            store.dispatch(showNotification(text, NotificationType[type]));
        }
    },
    showModal: (component, childrenModalProps, parentModalProps) => {
        modalSubject.next({
            component: component.bind(null, childrenModalProps),
            parentModalProps,
        });
    },
    hideModal: () => {
        modalSubject.next(null);
    },
    updateModal: (component, childrenModalProps) => {
        modalSubject.next({ component: component.bind(null, childrenModalProps) });
    },
    createExtensionHandlers: (handlers) => {
        for (const key in handlers) {
            if (!extensionHandlers.get(key)) {
                extensionHandlers.set(key, handlers[key]);
            }
        }
    },
    executeExtensionHandler: async (handlerData) => {
        return sendMessageFunc(handlerData.target, {
            ...handlerData,
            type: MessageType.ACTION_REQUEST,
        });
    },
    installExtensionHandler: async (handlerData) => {
        return sendMessageFunc(handlerData.target, {
            ...handlerData,
            type: MessageType.INSTALL_EXTENSION,
        });
    },
    addPersonToGroupCallByUid: (uid) => {
        angularServicesIntegration.get(AngularMethods.ADD_PERSON_TO_GROUP_CALL_BY_UID)(uid);
    },
    changeGlobalUiModalOpenProperty: (open) => {
        const globalUi = angularServicesIntegration.get(AngularServices.GLOBAL_UI);
        if (globalUi === undefined) {
            return;
        }
        globalUi.modalOpen = open;
    },
    showGlobalUiSidebar: () => {
        const globalUi = angularServicesIntegration.get(AngularServices.GLOBAL_UI);
        if (globalUi === undefined) {
            return;
        }
        globalUi.sidebarHidden = false;
    },
    hideGlobalUiSidebar: () => {
        const globalUi = angularServicesIntegration.get(AngularServices.GLOBAL_UI);
        if (globalUi === undefined) {
            return;
        }
        globalUi.sidebarHidden = true;
    },
    changeGlobalUisShowingWhiteboard: (isShowingWhiteboard) => {
        const rootScope = getAngularService(AngularServices.RootScope);
        rootScope.$emit(ExtensionsEventsEnum.IS_SHOWING_WHITEBOARD, isShowingWhiteboard);
    },
    changeGlobalUIIsShowingAdherely: (isShowingAdherely) => {
        const globalUi = angularServicesIntegration.get(AngularServices.GLOBAL_UI);
        if (globalUi === undefined) {
            return;
        }
        globalUi.isShowingAdherely = isShowingAdherely;
        const rootScope = getAngularService(AngularServices.RootScope);
        rootScope.$emit(ExtensionsEventsEnum.IS_SHOWING_ADHERELY, isShowingAdherely);
    },
    changeGlobalUIScreenSharing: (value) => {
        const globalUi = getAngularService(AngularServices.GLOBAL_UI);
        if (globalUi === undefined) {
            return;
        }
        globalUi.ui.screenSharing = value;
    },
    showCallFrame: (component, props) => {
        callFrameSubject.next({ component: component.bind(null, props) });
    },
    updateCallFrameComponent: (props) => {
        callFrameSubject.next({ props });
    },
    hideCallFrame: () => {
        callFrameSubject.next(null);
    },
    trackEvent: (eventName, property, context) => {
        const tracking = angularServicesIntegration.get(AngularMethods.GLOBAL_TRACKING);
        if (tracking === undefined) {
            return;
        }
        tracking.track(eventName, property, context);
    },
    trackEventButtonClick: (btnProperties) => {
        const tracking = angularServicesIntegration.get(AngularMethods.GLOBAL_TRACKING);
        if (tracking === undefined) {
            return;
        }
        tracking.trackButtonClick(btnProperties);
    },
    onClickExtensionItem: async (extName, menuType, startMethod) => {
        try {
            // todo: need to be approved with Data Team track event name
            // actions.trackEvent('Click on menu', {
            //   extension_name: extName,
            //   extension_type: menuType,
            // }, {});
            await startMethod();
        }
        catch (errorMessage) {
            throw new Error(errorMessage);
        }
    },
    getRoomUrl: () => {
        const getRoom = angularServicesIntegration.get(AngularMethods.GET_ROOM);
        const getRoomUrl = angularServicesIntegration.get(AngularMethods.GET_ROOM_URL);
        if (getRoom === undefined || getRoomUrl === undefined) {
            return null;
        }
        const room = getRoom();
        if (room === null) {
            return null;
        }
        return getRoomUrl(room);
    },
    videoProviderFactory: () => {
        return angularServicesIntegration.get(AngularServices.VIDEO_PROVIDER_FACTORY);
    },
    activeProvider: () => {
        return angularServicesIntegration.get(AngularServices.VIDEO_PROVIDER_FACTORY).activeProvider;
    },
    b64toBlob: (b64Data, contentType, sliceSize = 512) => {
        const b64toBlob = angularServicesIntegration.get(AngularMethods.B64_TO_BLOB);
        if (b64toBlob === undefined) {
            return null;
        }
        return b64toBlob(b64Data, contentType, sliceSize);
    },
    sendRequest: async (data) => {
        return createExtensionRequest(data);
    },
};
export const events = {
    onDoctorManuallyEndedCall: (func) => {
        callEndedByDoctorManuallySubscription.subscribe(func);
        return (subscribeFunc) => callEndedByDoctorManuallySubscription.unsubscribe(subscribeFunc);
    },
    onPersonManuallyRemovedFromCall: (func) => {
        personManuallyRemovedFromCallSub.subscribe(func);
        return (subscribeFunc) => personManuallyRemovedFromCallSub.unsubscribe(subscribeFunc);
    },
    onPatientManuallyEndedCall: (func) => {
        callEndedByPatientManuallySubscription.subscribe(func);
        return (subscribeFunc) => callEndedByPatientManuallySubscription.unsubscribe(subscribeFunc);
    },
    onActiveProviderEndReason: (func) => {
        activeProviderEndReasonSubscription.subscribe(func);
        return (subscribeFunc) => activeProviderEndReasonSubscription.unsubscribe(subscribeFunc);
    },
    onDoctorLeft: (func) => {
        doctorLeftSubscription.subscribe(func);
        return (subscribeFunc) => doctorLeftSubscription.unsubscribe(subscribeFunc);
    },
    onHoldCall: (func) => {
        callOnHoldSubscription.subscribe(func);
        return (subscribeFunc) => callOnHoldSubscription.unsubscribe(subscribeFunc);
    },
    onCallPausedForPatient: (func) => {
        callPausedForPatientSubscription.subscribe(func);
        return (subscribeFunc) => callPausedForPatientSubscription.unsubscribe(subscribeFunc);
    },
    onAngularModalOpen: (func) => {
        angularModalOpenedSubscription.subscribe(func);
        return (subscribeFunc) => angularModalOpenedSubscription.unsubscribe(subscribeFunc);
    },
    onAngularModalClose: (func) => {
        angularModalClosedSubscription.subscribe(func);
        return (subscribeFunc) => angularModalClosedSubscription.unsubscribe(subscribeFunc);
    },
    onPersonAddedToGroupCall: (func) => {
        personAddedToGroupCallSubscription.subscribe(func);
        return (subscribeFunc) => personAddedToGroupCallSubscription.unsubscribe(subscribeFunc);
    },
    onSessionConnected: (func) => {
        sessionConnectedSubscription.subscribe(func);
        return (subscribeFunc) => sessionConnectedSubscription.unsubscribe(subscribeFunc);
    },
    onSessionDisconnected: (func) => {
        sessionDisconnectedSubscription.subscribe(func);
        return (subscribeFunc) => sessionDisconnectedSubscription.unsubscribe(subscribeFunc);
    },
    onScreenSharingUpdated: (func) => {
        screenSharingUpdatedSubscription.subscribe(func);
        return (subscribeFunc) => screenSharingUpdatedSubscription.unsubscribe(subscribeFunc);
    },
    onScreenSharingStarted: (func) => {
        screenSharingStartedSubscription.subscribe(func);
        return (subscribeFunc) => screenSharingStartedSubscription.unsubscribe(subscribeFunc);
    },
    onScreenPublisherError: (func) => {
        screenPublisherErrorSubscription.subscribe(func);
        return (subscribeFunc) => screenPublisherErrorSubscription.unsubscribe(subscribeFunc);
    },
};
export async function extensionRequest(data) {
    return createExtensionRequest(data);
}
export function getExtensionTranslation(translation, values) {
    return localeService.formatMessageById(translation, values);
}
export function updateTranslations(translation) {
    localeService.updateTranslations(translation);
}
